module.exports = __webpack_public_path__ + "img/49.1cc00eb9.jpg";